import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import welcomeImg from '../images/profile-picture.png'
import ParticlesBackground from './ParticlesBackground';
import { HomeSection } from '../styles/home.style';

const ParticleStyles = styled.div`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        opacity: 0.5;

        & #tsparticles {
            width: 100%;
            height: 100%;
        }
`;

const Home = () => {
    return (
        <HomeSection id="/">
            <div className="container">
                <div className="row full-screen align-items-center">
                    <div className="greetings">
                        <p>Hi</p>
                        <h2>I'm Johnpaul Attamah</h2>
                        <p className="work">I design and develop web applications</p>
                        <Link 
                            to="projects"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={500}
                            className="btn-link outside-shadow hover-in-shadow"
                            activeClass="active"
                        >
                            view my work <span>&rarr;</span></Link>
                    </div>
                    <div className="welcome-img">
                        <div className="img-box inner-shadow">
                            <img src={welcomeImg} alt="welcome profile" className="outside-shadow" />
                        </div>
                    </div>
                </div>
                <ParticleStyles>
                    <ParticlesBackground/>
                </ParticleStyles>
            </div>
        </HomeSection>
    )
}

export default Home
